import { DocumentArchivePortalSharedResourceConfig, PortalSharedResource, PortalSharedResourceType, PortalSharedResourceTypes, SurveySegment } from '../../../DTOs';
import { basicValidation } from '../basicValidation';
import { fileFieldValidation } from './fileFieldValidation';
import { surveyValidation } from './surveyFieldValidation';

export const portalSharedResourceFieldValidation = {
    portalSharedResource: {
        sharedResourceId: (value: string) => basicValidation.resourceId.isValid(value),
        resourceId: (value: string) => 
            basicValidation.resourceId.isValid(value) ||
            fileFieldValidation.fileRecord.privateFileName(value),
        resourceType: (value: PortalSharedResourceType) => isValidResourceType(value),
        spec: (value: unknown) =>
        {
            if (!isObject(value))
                return false;

            const resourceType = value.resourceType as PortalSharedResourceType;
            const config = value.config;

            if (!isValidResourceType(resourceType))
                return false;

            if (resourceType === 'DocumentArchiveFile')
                return isDocumentArchiveConfig(config);

            else if(resourceType === 'SurveyReport')
                return isSurveyReportConfig(config);

            else if(resourceType === 'ExternalLink')
                return isExternalLinkConfig(config);

            return false;
        },

    }
};

function isObject(value: unknown): value is Record<string, unknown>
{
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function isValidResourceType (value: PortalSharedResourceType)
{
    return PortalSharedResourceTypes.includes(value);
}

function isDocumentArchiveConfig(value: unknown): value is PortalSharedResource['config']
{
    if (!isObject(value))
        return false;

    const keys = Object.keys(value);
    if (keys.length !== 1 || keys[0] !== 'note')
        return false;

    const config = value as DocumentArchivePortalSharedResourceConfig;
    return basicValidation.resourceText.isValid(config.note, true, 1000);
}

function isSurveyReportConfig(value: unknown): value is PortalSharedResource['config']
{
    if (!isObject(value))
        return false;

    const keys = Object.keys(value);
    if (keys.length !== 1 || keys[0] !== 'segmentFilter')
        return false;

    if(!Array.isArray(value.segmentFilter))
        return false;

    if(value.segmentFilter.length === 0)
        return false;

    return surveyValidation.surveySegment.validateUniqueListOfLists(value.segmentFilter as SurveySegment[][]);
}

function isExternalLinkConfig(value: unknown): value is PortalSharedResource['config']
{
    if (!isObject(value))
        return false;

    const keys = Object.keys(value);
    if (keys.length !== 0)
        return false;

    return true;
}
